// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector, Selector } from 'reselect';
import { ExamInformation } from '../../../types/Model';
import { ExamInformationState } from '../../reducers/examInformationReducer';

import { RootState } from '../../rootReducer';

export const ExamsRaw = (state: RootState):ExamInformationState => state.examInformationReducer;

export const makeExamByIdSelector = (id: number): Selector<RootState, ExamInformation> =>
  createSelector(
    ExamsRaw,
    (examInformationReducer) => examInformationReducer.examInformation[id] || {} as ExamInformation
  );

export const makeIsFetchingExam = (): Selector<RootState, boolean> => {
  return createSelector(
    ExamsRaw,
    (examInformationReducer) => examInformationReducer.isLoading
  );
};

export const makeError = (): Selector<RootState, Error | undefined> => {
  return createSelector(
    ExamsRaw,
    (examInformationReducer) => examInformationReducer.error
  );
}
